__webpack_require__.p = "/GPT-5/";